import type { IconName } from '../Icon';

import type { ModuleSidebarItem } from '../ModuleSidebar';

export type ProductModuleId =
  | 'recruitment'
  | 'front-desk'
  | 'education'
  | 'hr'
  | 'inventory'
  | 'finance'
  | 'family-school'
  | 'reports';

export interface ProductModuleDefinition {
  readonly groups: readonly (readonly ModuleSidebarItem[])[];
  readonly icon: IconName;
  readonly id: ProductModuleId;
  readonly label: string;
}

function secondaryRoute(moduleId: ProductModuleId, label: string): string {
  if (moduleId === 'education' && label === '课表和点名') return '#/teacher-schedule';
  if (moduleId === 'recruitment' && label === '意向学员管理') return '#/intention-student';
  if (moduleId === 'recruitment' && label === '优惠券管理') return '#/coupon-management';
  if (moduleId === 'recruitment' && label === '电子推荐卡管理') return '#/recommendation-card-management';
  return `#/modules/${moduleId}/${encodeURIComponent(label)}`;
}

function group(moduleId: ProductModuleId, labels: readonly string[]): readonly ModuleSidebarItem[] {
  return labels.map((label) => ({ label, href: secondaryRoute(moduleId, label) }));
}

export const productModules: readonly ProductModuleDefinition[] = [
  {
    id: 'recruitment',
    label: '招生营销',
    icon: 'shouqiangl',
    groups: [group('recruitment', ['意向学员管理', '邀约查询', '招生海报', '客户跟进统计', '呼叫中心报表', '意向客户导入', '招生代理管理', '优惠券管理', '优惠方案管理', '优惠方案设置', '电子推荐卡管理', '储值卡管理'])],
  },
  {
    id: 'front-desk',
    label: '前台业务',
    icon: 'qiantaiyw',
    groups: [
      group('front-desk', ['学员信息管理']),
      group('front-desk', ['收费', '结转', '退费']),
      group('front-desk', ['交班', '缴款']),
      group('front-desk', ['订单管理', '先学后付签约', '积分管理', '试听管理', '转校管理', '套餐设置']),
      group('front-desk', ['公告与通知', '折扣审批', '学员信息导入']),
    ],
  },
  {
    id: 'education',
    label: '教务管理',
    icon: 'jiaowugl',
    groups: [
      group('education', ['课程管理', '班级管理', '排课管理', '约课管理', '课表和点名']),
      group('education', ['补课管理', '评测管理', '考试管理', '宿舍管理']),
      group('education', ['学管师带班', '证书管理', '校管家云课', '升班关系设置', '在线课堂']),
    ],
  },
  {
    id: 'hr',
    label: '人事管理',
    icon: 'renshigl',
    groups: [
      group('hr', ['目标值管理', '指标管理', '审批中心', '工资管理']),
      group('hr', ['自定义报表']),
    ],
  },
  {
    id: 'inventory',
    label: '经销存管理',
    icon: 'jinxiaocun',
    groups: [group('inventory', ['仓库管理', '物品设置', '库存查询', '进出库管理', '进出库查询', '预出库管理', '库存变动表'])],
  },
  {
    id: 'finance',
    label: '财务管理',
    icon: 'caiwugl',
    groups: [
      group('finance', ['经贝管家', '收支流水', '在线支付对账', '收费管家']),
      group('finance', ['结转审批', '转费审批', '退费处理', '缴款确认', '数据维护', '统计报表']),
      group('finance', ['发票管理', '呆滞费用清理', '公司主体信息管理', '财务安全管理']),
    ],
  },
  {
    id: 'family-school',
    label: '家校服务',
    icon: 'shishengxin',
    groups: [
      group('family-school', ['AI家校圈', '网上商城', '课后点评', '学员作品集', '电子相册', '问卷收集']),
      group('family-school', ['通知', '打卡', '作业', '群消息', '个人消息', '老师评价学生', '家长评价老师', '投诉']),
      group('family-school', ['学员端管理']),
    ],
  },
  {
    id: 'reports',
    label: '报表中心',
    icon: 'reportcenter',
    groups: [
      group('reports', ['BI课消汇总表']),
      group('reports', ['招生分析报表', '学员分析报表', '电子推荐卡报表', '收费报表', '课消报表', '业绩报表', '班级报表']),
      group('reports', ['运营数据大屏', '老版收费', '收费3.0']),
    ],
  },
];

export function findProductModule(moduleId: string | undefined): ProductModuleDefinition | undefined {
  return productModules.find((item) => item.id === moduleId);
}

export function findModuleMenuItem(module: ProductModuleDefinition, label: string): ModuleSidebarItem | undefined {
  return module.groups.flat().find((item) => item.label === label);
}
